import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";

import { StoreField } from "@/components/Form/RHF/FormFields/StoreField/storeField.container";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { getShopNames } from "@/redux/modules/api/data/stores/shopNames/shopNames.selector";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useSingleStoreCheck } from "@/utils/hooks/store/useSingleStoreCheck.hook";

import { CheckoutCustomerFormValues } from "../checkoutCustomer.schema";

type StoreProps = {
    excludeStores?: Array<string>;
};

const Store = ({ excludeStores }: StoreProps) => {
    const { t } = useGranite();
    const shopNames = useSelector(getShopNames, shallowEqual);
    const singleStoreCode = useSingleStoreCheck();

    const { setValue, getValues } =
        useFormContext<CheckoutCustomerFormValues>();

    useEffect(() => {
        if (singleStoreCode && singleStoreCode !== getValues("storeId")) {
            setValue("storeId", singleStoreCode);
        }
    }, [singleStoreCode, setValue, getValues]);

    return (
        <section className={"mb-4"}>
            <h2>{t("checkout.customerDetails.store.title")}</h2>
            <hr />
            <p>
                <i>{t("checkout.customerDetails.store.subtitle")}</i>
            </p>
            <Row>
                <Col
                    data-test="checkoutCustomer-store"
                    md={10}
                    lg={8}
                    xl={6}
                >
                    <StoreField<CheckoutCustomerFormValues>
                        name={"storeId"}
                        label={t("general.form.store.label")}
                        placeholder={t("general.form.store.placeholder")}
                        required
                        storeList={shopNames}
                        excludeStores={excludeStores}
                    />
                </Col>
            </Row>
        </section>
    );
};

export { Store };
